var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLightning = function SvgLightning(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27 10.5c-.6-1.1-1.7-1.9-3-1.9h-2.5l1.3-3.5c.2-.4.3-.8.3-1.3C23.1 2 21.6.5 19.8.5h-6.3c-1.4 0-2.7.9-3.1 2.2L5.9 15c-.4 1-.2 2.2.4 3 .6 1 1.6 1.5 2.7 1.5h1.9l-2.7 7.7c-.5 1.5.1 3.2 1.6 4 .5.3 1 .4 1.6.4 1 0 2-.5 2.6-1.3L26.7 14c.7-1 .9-2.3.3-3.5m-3.5 1.7L12.1 26.9 15.9 16H9.4l4.3-11.8h5.7l-3.1 8.1z"
  })));
};
export default SvgLightning;